import axios from 'axios'

import { APP } from 'src/Configs/App'

import { api } from './api'

const UPLOAD_REQUEST_TIMEOUT = 300000
const TIMEOUT_ERROR_CODES = ['ECONNABORTED', 'ETIMEDOUT']

export interface PreReleaseTrackFileResponse {
  audioUrl: string
}

export interface PreReleaseTrackFileUploadProgress {
  loaded: number
  total: number
  secondsLeft: number | null
}

export interface UploadPreReleaseTrackFileParams {
  campaignId: string
  file: File
  signal?: AbortSignal
  onProgress?: (progress: PreReleaseTrackFileUploadProgress) => void
}

const getTrackFileUrl = (campaignId: string): string =>
  `${APP.TIKTOK_SERVER}/artist/spotify-campaigns/${campaignId}/pre-release-track-file`

export const isUploadTimeoutError = (error: unknown): boolean =>
  axios.isAxiosError(error) && TIMEOUT_ERROR_CODES.includes(error.code || '')

export const uploadPreReleaseTrackFile = async ({
  campaignId,
  file,
  signal,
  onProgress,
}: UploadPreReleaseTrackFileParams): Promise<PreReleaseTrackFileResponse> => {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await api.post<PreReleaseTrackFileResponse>(
    getTrackFileUrl(campaignId),
    formData,
    {
      timeout: UPLOAD_REQUEST_TIMEOUT,
      ...(signal ? { signal } : {}),
      onUploadProgress: ({ loaded, total, estimated }) => {
        onProgress?.({
          loaded,
          total: total || file.size,
          secondsLeft:
            typeof estimated === 'number' && Number.isFinite(estimated)
              ? estimated
              : null,
        })
      },
    },
  )

  return data
}

export const deletePreReleaseTrackFile = async (
  campaignId: string,
): Promise<void> => {
  await api.delete(getTrackFileUrl(campaignId))
}
